.date-input {
    height: 30px;
    border: 1px solid var(--off-white-dk);
    padding-left: 6px;
    border-radius: 3px;
    color: var(--grey);
}
